// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.print-slide {
  --clr-dark-400: #6D6E71;
  --clr-dark-500: #5C5D60;
  --clr-dark-600: #343333;
  --clr-grey-400: #e6e6e6;
  --clr-white: #fff;
  --ff-light: "Helvetica LT W05 Light", sans-serif;
  --ff-normal: "Helvetica LT W05 Roman" , sans-serif;
  --ff-bold: "Helvetica LT W05 Bold", sans-serif;
  width: 100%;
  background-color: var(--clr-white);
  display: none;
}
.print-slide .wrapper {
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
}
.print-slide .learner__map-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
}
.print-slide .learner__map-header .map-name {
  font-size: 24px;
  font-family: var(--ff-bold);
  color: var(--clr-dark-400);
  padding-right: 15px;
}
.print-slide .learner__map-header .logo {
  width: 200px;
}
.print-slide .learner__map-header .logo a {
  display: block;
}
.print-slide .learner__map-header .logo img {
  width: 100%;
  height: auto;
}
.print-slide .learner__map-table {
  border: 1px solid var(--clr-dark-400);
  border-radius: 4px;
  overflow: hidden;
}
.print-slide .learner__map-table > div {
  border-top: 1px solid var(--clr-dark-400);
}
.print-slide .learner__map-table > div:nth-child(1),
.print-slide .learner__map-table > div:nth-child(2) {
  border-top: none;
}
.print-slide .lerner__table-col {
  display: flex;
  flex-wrap: wrap;
}
.print-slide .lerner__table-col:first-child {
  background-color: var(--clr-dark-400) !important;
  text-align: center;
}
.print-slide .lerner__table-col:first-child > div {
  color: var(--clr-white) !important;
  border: 0 !important;
  margin: 0 !important;
}
.print-slide .lerner__table-col:first-child .thumbnail {
  width: 25%;
}
.print-slide .lerner__table-col:first-child .script {
  width: 71%;
}
.print-slide .lerner__table-col > div {
  padding: 10px;
}
.print-slide .lerner__table-col > div:first-child {
  width: 4%;
}
.print-slide .lerner__table-col > div:nth-child(2) {
  width: 50%;
}
.print-slide .lerner__table-col > div:last-child {
  width: 92%;
}
.print-slide .lerner__table-col > div {
  font-size: 16px;
  font-family: var(--ff-normal);
  color: var(--clr-dark-500);
}
.print-slide .learner__map-table > div:nth-child(1) {
  background: var(--clr-dark-400);
}
.print-slide .learner__map-table > div:nth-child(1) div {
  font-size: 20px;
  font-family: var(--ff-bold);
  color: var(--clr-white);
}
.print-slide .learner__map-table .thumbnail-pic {
  position: relative;
  height: 100%;
}
.print-slide .learner__map-table .thumbnail-pic img {
  width: 100%;
  height: auto;
}
.print-slide .thumbnail-pic .content {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.print-slide .thumbnail-pic .content h4 {
  padding: 10px 10px;
  margin: 0;
  font-size: 18px;
  color: var(--clr-white);
}
.print-slide .thumbnail--data {
  width: 250px;
  float: left;
  margin-right: 30px;
  margin-bottom: 5px;
}
.print-slide .thumbnail--data .script span {
  color: #fff !important;
}
.print-slide .learner__map-table p {
  margin: 0 0 10px 0;
}
.print-slide .learner__map-table p:last-child {
  margin-bottom: 0;
}
.print-slide .learner__map-table ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.print-slide .learner__map-table ul li + li {
  margin-top: 4px;
}

@media print {
  ::ng-deep.lmslider {
    display: none !important;
  }
  ::ng-deep.TCWA {
    display: none;
  }
  .print-slide {
    display: block;
  }
  ::ng-deep.lm-an-cards__print {
    display: none;
  }
  ::ng-deep.start-work__popuprow--content .title {
    margin: 0;
  }
  ::ng-deep.practioner-dash-wrap--ss {
    padding: 0 !important;
  }
  ::ng-deep.start-work__popuprow--content {
    background-image: none !important;
  }
  ::ng-deep.up_only_print .thumbnail--data {
    width: 50% !important;
  }
  ::ng-deep.up_only_print .thumbnail--data .custom-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/learner-maps/dynamic-learner-map/dynamic-card/slideshow-print/slideshow-print.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACH,uBAAA;EACA,uBAAA;EAEA,uBAAA;EAEA,iBAAA;EAEA,gDAAA;EACA,kDAAA;EACA,8CAAA;EACG,WAAA;EACA,kCAAA;EACA,aAAA;AAFJ;AAGI;EAEI,WAAA;EACA,eAAA;EACA,cAAA;AAFR;AAII;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAFR;AAII;EACI,eAAA;EACA,2BAAA;EACA,0BAAA;EACA,mBAAA;AAFR;AAII;EACI,YAAA;AAFR;AAII;EACI,cAAA;AAFR;AAII;EACI,WAAA;EACA,YAAA;AAFR;AAII;EACI,qCAAA;EACA,kBAAA;EACA,gBAAA;AAFR;AAII;EACI,yCAAA;AAFR;AAII;;EAEI,gBAAA;AAFR;AAKI;EACI,aAAA;EACA,eAAA;AAHR;AAKQ;EACI,gDAAA;EACA,kBAAA;AAHZ;AAKY;EACI,kCAAA;EACA,oBAAA;EACA,oBAAA;AAHhB;AAMY;EACI,UAAA;AAJhB;AAOY;EACI,UAAA;AALhB;AAUI;EACI,aAAA;AARR;AAUI;EACI,SAAA;AARR;AAUI;EACI,UAAA;AARR;AAUI;EACI,UAAA;AARR;AAUI;EACI,eAAA;EACA,6BAAA;EACA,0BAAA;AARR;AAUI;EACI,+BAAA;AARR;AAUI;EACI,eAAA;EACA,2BAAA;EACA,uBAAA;AARR;AAUI;EACI,kBAAA;EACA,YAAA;AARR;AAUI;EACI,WAAA;EACA,YAAA;AARR;AAUI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AARR;AAUI;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AARR;AAWI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AATR;AAaY;EACI,sBAAA;AAXhB;AAgBI;EACI,kBAAA;AAdR;AAgBI;EACI,gBAAA;AAdR;AAgBI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AAdR;AAgBI;EACI,eAAA;AAdR;;AAkBA;EACI;IACI,wBAAA;EAfN;EAkBE;IACI,aAAA;EAhBN;EAmBE;IACI,cAAA;EAjBN;EAoBE;IACI,aAAA;EAlBN;EAuBM;IACI,SAAA;EArBV;EAyBE;IACI,qBAAA;EAvBN;EA0BE;IACI,iCAAA;EAxBN;EA2BE;IACI,qBAAA;EAzBN;EA2BM;IACI,aAAA;IACA,qCAAA;EAzBV;AACF","sourcesContent":[".print-slide {\n    --clr-dark-400: #6D6E71;\n\t--clr-dark-500: #5C5D60;\n\t--clr-dark-600: #343333;\n\n\t--clr-grey-400:  #e6e6e6;\n\t\t\t\n\t--clr-white: #fff;\n\n\t--ff-light: \"Helvetica LT W05 Light\", sans-serif;\n\t--ff-normal: \"Helvetica LT W05 Roman\" , sans-serif;\n\t--ff-bold: \"Helvetica LT W05 Bold\", sans-serif;\n    width: 100%;\n    background-color: var(--clr-white);\n    display: none;\n    .wrapper{\n        // max-width: 850px;\n        width: 100%;\n        padding: 0 15px;\n        margin: 0 auto;\n    }\n    .learner__map-header{\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: space-between;\n        margin: 15px 0;\n    }\n    .learner__map-header .map-name{\n        font-size: 24px;\n        font-family: var(--ff-bold);\n        color: var(--clr-dark-400);\n        padding-right: 15px;\n    }\n    .learner__map-header .logo{\n        width: 200px;\n    }\n    .learner__map-header .logo a{\n        display: block;\n    }\n    .learner__map-header .logo img{\n        width: 100%;\n        height: auto;\n    }\n    .learner__map-table{\n        border: 1px solid var(--clr-dark-400);\n        border-radius: 4px;\n        overflow: hidden;\n    }\n    .learner__map-table > div{\n        border-top: 1px solid var(--clr-dark-400);\n    }\n    .learner__map-table > div:nth-child(1),\n    .learner__map-table > div:nth-child(2){\n        border-top: none;\n    }\n\n    .lerner__table-col{\n        display: flex;\n        flex-wrap: wrap;\n\n        &:first-child {\n            background-color: var(--clr-dark-400) !important;\n            text-align: center;\n            \n            & > div {\n                color: var(--clr-white) !important;\n                border: 0 !important;\n                margin: 0 !important;\n            }\n\n            .thumbnail {\n                width: 25%;\n            }\n\n            .script {\n                width: 71%;\n            }\n        }\n    }\n\n    .lerner__table-col > div{\n        padding: 10px;\n    }\n    .lerner__table-col > div:first-child{\n        width: 4%; \n    }\n    .lerner__table-col > div:nth-child(2){\n        width: 50%;\n    }\n    .lerner__table-col > div:last-child{\n        width: 92%;\n    }\n    .lerner__table-col > div{\n        font-size: 16px;\n        font-family: var(--ff-normal);\n        color: var(--clr-dark-500);\n    }\n    .learner__map-table > div:nth-child(1){\n        background: var(--clr-dark-400);\n    }\n    .learner__map-table > div:nth-child(1) div{\n        font-size: 20px;\n        font-family: var(--ff-bold);\n        color: var(--clr-white);\n    }\n    .learner__map-table .thumbnail-pic{\n        position: relative;\n        height: 100%;\n    }\n    .learner__map-table .thumbnail-pic img{\n        width: 100%;\n        height: auto;\n    }\n    .thumbnail-pic .content{\n        width: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    .thumbnail-pic .content h4{\n        padding: 10px 10px;\n        margin: 0;\n        font-size: 18px;\n        color: var(--clr-white);\n    }\n\n    .thumbnail--data {\n        width: 250px;\n        float: left;\n        margin-right: 30px;\n        margin-bottom: 5px;\n\n        .script {\n\n            span {\n                color: #fff !important;\n            }\n        }\n    }\n\n    .learner__map-table p{\n        margin: 0 0 10px 0;\n    }\n    .learner__map-table p:last-child{\n        margin-bottom: 0;\n    }\n    .learner__map-table ul{\n        padding: 0;\n        margin: 0;\n        list-style: none;\n    }\n    .learner__map-table ul li + li{\n        margin-top: 4px;\n    }\n}\n\n@media print {\n    ::ng-deep.lmslider {\n        display: none !important;\n    }\n\n    ::ng-deep.TCWA {\n        display: none;\n    }\n\n    .print-slide {\n        display: block;\n    }\n\n    ::ng-deep.lm-an-cards__print {\n        display: none;\n    }\n\n    ::ng-deep.start-work__popuprow--content {\n\n        .title {\n            margin: 0;\n        }\n    }\n\n    ::ng-deep.practioner-dash-wrap--ss {\n        padding: 0 !important;\n    }\n\n    ::ng-deep.start-work__popuprow--content {\n        background-image: none !important;\n    }\n\n    ::ng-deep.up_only_print .thumbnail--data {\n        width: 50% !important;\n\n        .custom-row {\n            display: grid;\n            grid-template-columns: repeat(4, 1fr);\n        }\n    }\n    \n\n    // ::ng-deep.lerner__table-content .thumbnail--data {\n    //     width: 100% !important;\n    //     margin-right: 0 !important;\n    // }\n    // ::ng-deep.skid__ups {\n    //     display: flex;\n    //     flex-wrap: wrap;\n    //     gap: 30px;\n    // }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
